import ContainerFlex from '~/components/containerFlex';
import { ReprocessamentoFaturaDados } from '~/models/reprocessamento-fatura';
import { Header } from '../header';
import { SolicitationDecisionActions } from '../solicitationDecisionActions';
import TransactionTable from '../transactionTable';
export const customerHeader = [
  { id: 0, value: 'id', type: 'id', hidden: true },
  {
    id: 1,
    value: 'Lançamento',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 2,
    value: 'Tipo',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Valor',
    maxChar: 30,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Data',
    maxChar: 20,
    textAlign: 'center',
  },
];
export default function InvoiceView({
  data,
  readOnly = false,
  action = false,
}: {
  data: ReprocessamentoFaturaDados;
  readOnly?: boolean;
  action?: boolean;
}) {
  return (
    <>
      <ContainerFlex
        row
        space
        gap="8"
        style={{
          maxHeight: '850px',
        }}
      >
        <ContainerFlex
          flex={1}
          style={{
            borderRadius: '16px',
          }}
        >
          <Header label="Pré visualização da fatura" />

          <iframe
            style={{ display: 'block' }}
            data-show={true}
            width="100%"
            height="100%"
            src={
              data.linkPdf ? `${data.linkPdf}#zoom=page-fit&view=FitH` : null
            }
          />
        </ContainerFlex>
        <ContainerFlex flex={1} style={{ borderRadius: '16px' }}>
          <Header label="Transações para remover" />

          <TransactionTable readOnly={readOnly} data={data} />

          {action ? (
            <SolicitationDecisionActions invoiceId={data.idFatura} />
          ) : null}
        </ContainerFlex>
      </ContainerFlex>
    </>
  );
}
